import StockForecast from '../../model/forecast-stock-data';
import MessageHelper from '../../helpers/message-helper';

export default class OrderDeadline {
  static readonly ASYNC_KEY = 'orderDeadline';

  private cutoffTimeFormatted: string | undefined;

  constructor(private container: HTMLElement, data: StockForecast[]) {
    this.cutoffTimeFormatted = data?.[0]?.cutoffTimeFormatted;
    this.render();
  }

  setStockForecast(data: StockForecast[]): void {
    this.cutoffTimeFormatted = data?.[0]?.cutoffTimeFormatted;
    this.render();
  }

  private render(): void {
    if (!this.cutoffTimeFormatted) {
      this.container.classList.add('d-none');
      return;
    }

    this.container.innerHTML = MessageHelper.getMessageWithAttributes('eparts.product.orderDeadline', this.cutoffTimeFormatted);
    this.container.classList.remove('d-none');
  }
}
